import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'
import { FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'
import { GetLeaderboardRequest, LeaderboardResponse } from 'types'

export const queryLeaderboard = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getLeaderboard: builder.query<LeaderboardResponse, GetLeaderboardRequest>({
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const { limit, page } = arg

        let url = `${apiPath.leaderboard}?`
        if (limit) {
          url = url.concat(`&limit=${limit}`)
        }
        if (page) {
          url = url.concat(`&page=${page}`)
        }

        const result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta> = await baseQuery({
          method: 'GET',
          url,
        })

        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: result.data as LeaderboardResponse }
      },
    }),
  }),
  reducerPath: 'leaderboard',
  tagTypes: ['Leaderboard'],
})

export const { useGetLeaderboardQuery, useLazyGetLeaderboardQuery } = queryLeaderboard
